module.exports = {"title":"Description","close":"Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Stream/StreamDescriptionModal/locales/en.json
// module id = 1814
// module chunks = 0